<div class="customer-history-section">
    @if (loading) {
        <div class="d-flex justify-content-center p-3">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Laden...</span>
            </div>
        </div>
    } @else {
        <table class="table w-100 mb-3">
            <thead>
                <tr>
                    <th scope="col">Klantgebied</th>
                    <th scope="col">Toegewezen op</th>
                    <th scope="col">Toegewezen door</th>
                    <th scope="col">Verwijderd op</th>
                    <th scope="col">Verwijderd door</th>
                    <th scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
                @for (historyItem of customerHistory; track historyItem.customer_id + '' + historyItem.assigned_at) {
                    <tr>
                        <td>
                            {{ historyItem.customer_name }}
                        </td>
                        <td>{{ historyItem.assigned_at | date: 'EEE d MMM y HH:mm' : '' : 'nl' }}</td>
                        <td>
                            <span class="text-muted">{{ historyItem.assigned_by_name }}</span>
                        </td>
                        <td>
                            @if (historyItem.removed_at) {
                                {{ historyItem.removed_at | date: 'EEE d MMM y HH:mm' : '' : 'nl' }}
                            } @else {
                                <span class="text-muted">-</span>
                            }
                        </td>
                        <td>
                            @if (historyItem.deleted_by_name && historyItem.removed_at) {
                                <span class="text-muted">{{ historyItem.deleted_by_name }}</span>
                            } @else {
                                <span class="text-muted">-</span>
                            }
                        </td>
                        <td>
                            @if (historyItem.is_active) {
                                <span class="text-success">Actief</span>
                            } @else {
                                <span class="text-danger">Verwijderd</span>
                            }
                        </td>
                    </tr>
                } @empty {
                    <tr>
                        <td colspan="6">
                            <div class="alert alert-info mb-0" role="alert">
                                <i class="bi bi-info-circle me-2"></i>
                                Geen klantgebieden geschiedenis gevonden voor deze gebruiker.
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    }
</div>
